import Fingerprint2 from 'fingerprintjs2'
import UAParser from 'ua-parser-js'
import Funcoes from '@/utils/Functions'
import _ from 'lodash'
import * as deviceAPI from '@/api/device'

const set = property => (state, payload) => (state[property] = payload)

const state = {
  listDevices: [],
  device: {},
  devicebd: {},
  hash: '',
  emailretorno: ''
}

const getters = {
  getEmailRetorno: (state) => {
    return state.emailretorno
  },
  getHash: (state) => {
    return state.hash
  },
  getDevice: (state) => {
    return state.device
  },
  getDevicebd: (state) => {
    return state.devicebd
  }

}

const actions = {

  listDevice: ({ commit }, filtros) => deviceAPI.listDevice(filtros)
    .then(res => {
      commit('LISTDEVICES', res)
      return res
    }),

  findDevice: ({ commit }, fingerprint) => deviceAPI.getDevice(fingerprint)
    .then(res => {
      commit('DEVICEBD', res)
      return res
    }),

  addDevice: ({ commit }, device) => deviceAPI.addDevice(device)
    .then(res => {
      commit('DEVICEBD', res)
      return res
    }),

  editDevice: ({ commit }, device) => deviceAPI.editDevice(device)
    .then(res => {
      commit('DEVICEBD', res)
      return res
    }),

  enviarEmailNovoDispositivo: ({ commit }, device) => deviceAPI.enviarEmailNovoDispositivo(device)
    .then(res => {
      commit('EMAILRETORNO', res)
      return res
    }),

  identificarDevice: ({ commit }) => {
    let hashUnico = ''
    const parser = new UAParser()

    const defaultOptions = {
      excludes: [
        'screenResolution',
        'availableScreenResolution',
        'doNotTrack',
        'plugins',
        'adBlock',
        'fonts'
      ]
    }

    if (window.requestIdleCallback) {
      requestIdleCallback(function () {
        Fingerprint2.get({
          excludes: {
            adBlock: true,
            fonts: true,
            fontsFlash: true,
            enumerateDevices: true, // TEMOS QUE EXCLUIR DEVIDO AO BUG, SENAO FICA ALTERANDO
            availableScreenResolution: true,
            doNotTrack: true,
            localStorage: true,
            addBehavior: true,
            // cpuClass: true,
            // canvas: true,
            // webdriver: true,
            colorDepth: true,
            // deviceMemory: true,
            // hardwareConcurrency: true, // usamos ele pra atribuir o seed na função abaixo
            timezoneOffset: true,
            sessionStorage: true,
            indexedDb: true,
            openDatabase: true,
            plugins: true,
            webgl: true,
            webglVendorAndRenderer: true,
            hasLiedLanguages: true,
            touchSupport: true,
            hasLiedResolution: true,
            hasLiedOs: true,
            hasLiedBrowser: true,
            audio: true
          },
          defaultOptions
        }, function (components) {
          // console.log('componentes', components)
          // const values = components.map(function (component) { return component.value })
          const seed = _.find(components, (obj) => obj.key === 'hardwareConcurrency').value
          // const canvas = _.find(components, (obj) => obj.key === 'canvas').value
          // console.log('canvas', canvas)
          // const hashUnico = Fingerprint2.x64hash128(values.join(''), seed)
          hashUnico = Fingerprint2.x64hash128(
            components.map((pair) => pair.value).join(), seed
          )
          commit('HASH', hashUnico)
        })
      })
    } else {
      setTimeout(function () {
        Fingerprint2.get({
          excludeAdBlock: true
        }, function (components) {
          const seed = _.find(components, (obj) => obj.key === 'hardwareConcurrency').value
          hashUnico = Fingerprint2.x64hash128(
            components.map((pair) => pair.value).join(), seed
          )
          commit('HASH', hashUnico)
        })
      }, 500)
    }

    const device = {
      ua: Funcoes.retornarStringSeNulo(parser.getUA()),
      arquitetura: Funcoes.retornarStringSeNulo(parser.getCPU().architecture),
      browser_nome: Funcoes.retornarStringSeNulo(parser.getBrowser().name),
      browser_versao: Funcoes.retornarStringSeNulo(parser.getBrowser().version),
      engine_nome: Funcoes.retornarStringSeNulo(parser.getEngine().name),
      os_nome: Funcoes.retornarStringSeNulo(parser.getOS().name),
      os_versao: Funcoes.retornarStringSeNulo(parser.getOS().version)
    }
    commit('DEVICE', device)
    return device
  }
}

const mutations = {
  DEVICE: set('device'),
  DEVICEBD: set('devicebd'),
  LISTDEVICES: set('device'),
  HASH: set('hash'),
  EMAILRETORNO: set('emailretorno')
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
